import React from 'react';
import PropTypes from 'prop-types';
import EmptyResults from '../EmptyResults';

function MediaUploadQuestionResults(props) {
  const { question, hasResponses } = props;
  const { data } = question;
  const totalCount = data?.totalCount ?? 0;
  const isEmpty = totalCount === 0;

  if (isEmpty) {
    return (
      <div style={{ padding: '2rem' }}>
        <EmptyResults hasResponses={hasResponses} />
      </div>
    );
  }

  return (
    <div className="engage-results-media-upload" style={{ padding: '1rem' }}>
      <p>
        <b>{totalCount}</b> {totalCount === 1 ? 'file' : 'files'} uploaded
      </p>
    </div>
  );
}

MediaUploadQuestionResults.propTypes = {
  question: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
      totalCount: PropTypes.number,
      files: PropTypes.arrayOf(
        PropTypes.shape({
          fileName: PropTypes.string,
          compositeFileName: PropTypes.string,
          uploadedAt: PropTypes.string,
        })
      ),
    }),
  }).isRequired,
  hasResponses: PropTypes.bool.isRequired,
};

export default MediaUploadQuestionResults;
